import angular from "angular";
import {
  progressivesDetailComponentOptions,
  vsName as progressivesDetailComponentOptionsName,
} from "./detail";
import {
  progressivesDetailMachinesComponentOptions,
  vsName as progressivesDetailMachinesComponentOptionsName,
} from "./detail/machines";
import {
  progressivesDetailMachinesEditComponentOptions,
  vsName as progressivesDetailMachinesEditComponentOptionsName,
} from "./detail/machines/edit";
import {
  machineProgressivesGridComponentOptions,
  vsName as machineProgressivesGridComponentOptionsName,
} from "./grid";

export const vsModuleName = "SlotTrak.Machines.Components.Progressives";

angular
  .module(vsModuleName, [])
  .component(
    progressivesDetailComponentOptionsName,
    progressivesDetailComponentOptions
  )
  .component(
    progressivesDetailMachinesComponentOptionsName,
    progressivesDetailMachinesComponentOptions
  )
  .component(
    progressivesDetailMachinesEditComponentOptionsName,
    progressivesDetailMachinesEditComponentOptions
  )
  .component(
    machineProgressivesGridComponentOptionsName,
    machineProgressivesGridComponentOptions
  );
